import { getApi } from "../helpers/api";

async function get(endpoint: string, id: any, queryParams: string = "", config?: any) {
  return await getApi().get(`/${endpoint}/${id}${queryParams}`, config);
}

export default get;
